import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadRiskTolerances,
  loadRiskTolerancesFailure,
  loadRiskTolerancesSuccess,
} from './risk-tolerances.actions';

@Injectable()
export class RiskTolerancesEffects {
  private readonly actions$ = inject(Actions);
  private readonly referenceService = inject(ReferenceService);

  loadRiskTolerances$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRiskTolerances),
      switchMap(() =>
        this.referenceService.referenceSasSecLookupGetRiskTolerancesGet().pipe(
          map((response) =>
            loadRiskTolerancesSuccess({
              riskTolerances: response.result || [],
            })
          ),
          catchError((error) => of(loadRiskTolerancesFailure({ error })))
        )
      )
    )
  );
}